<mat-form-field class="dict-address">
  <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)"  [placeholder]="label">
    <mat-option>
      <ngx-mat-select-search [formControl]="filterCtrl" placeholderLabel="Wyszukaj..."
                             noEntriesFoundLabel="Nie znaleziono wartości">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let option of items" [value]="option.value">
      {{option.value}}
    </mat-option>
  </mat-select>
  <button *ngIf="((control.value !== null
     && control.value.hasOwnProperty('length')
    &&  control.value))
    && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
</mat-form-field>
